import { NgModule } from '@angular/core'
import { SeApiModule } from '../se-api'

@NgModule({
  imports: [
    SeApiModule,
  ]
})
export class SeServiceModule { }
